import React, { useState, useEffect } from "react";
import errorIcon from '../../assets/img/error-icon.svg'

interface InputProps {
  type: string;
  inputValue: string;
  onSetInput: (value: string) => void;
  validationFunc?: (value: string) => boolean;
  placeholder?: string;
  invalidMsg?: string;
}

export const LoginInput: React.FC<InputProps> = ({
  type,
  inputValue,
  onSetInput,
  validationFunc,
  placeholder,
  invalidMsg,
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!isTouched || !validationFunc) return;
    const timeoutId = setTimeout(() => {
      const isValidInput = validationFunc(inputValue);

      if (!isValidInput) setIsError(true);
      else setIsError(false);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [inputValue, isTouched, validationFunc]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isTouched) setIsTouched(true);
    onSetInput(e.target.value);
  };

  return (
    <div className="login-input">
      <div>
        <input
          type={type}
          placeholder={placeholder}
          className={isError ? "error-icon" : ""}
          value={inputValue}
          onChange={onChange}
        />

        {isError && (
          <img
            src={errorIcon}
            alt="error"
            className="error-icon"
          />
        )}
      </div>
      {isError && (
        <p className="error-msg">
          {invalidMsg ? invalidMsg : "Invalid input"}
        </p>
      )}
    </div>
  );
};
